<template>
  <div style="width:100%;float:left;">
    <CButton size="sm" color="info" v-if="!selectedItem" @click="$emit('back')" style="margin-bottom:5px;">Back</CButton>
    <CButton size="sm" color="info" v-else @click="selectedItem = null" style="margin-bottom:5px;">Back</CButton>
    <CCard v-if="reportData && !selectedItem">
      <CCardHeader v-if="reportType !== 'monthly'">{{reportData[0].area}} Report</CCardHeader>
      <CCardHeader v-else>{{reportData}} Report</CCardHeader>
      <CCardBody>
        <!-- <table class='table'>
          <thead>
            <tr>
              <th>Sold To</th>
              <th>Booked</th>
              <th>Shipped</th>
              <th>Balance Open</th>
              <th>Late Open</th>
              <th>Total Open</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="val in reportData">
              <td>{{val.sold_to_number}}</td>
              <td>{{val.daily_booked}}</td>
              <td>{{val.daily_shipped}}</td>
              <td>{{val.balance_open}}</td>
              <td>{{val.late_open}}</td>
              <td>{{val.total_open}}</td>
            </tr>
          </tbody>
        </table> -->

        <div style="width:100%;float:left;" v-if="!loading">
          <h5 style="width:100%;float:left;text-align:center;font-size:11px;color: grey;text-align:center;">Click on a row to view that sold to's open orders...</h5>
          <CButton
            v-if="data"
            color="primary"
            class="mb-2"
            size="sm"
            :href="csvCode" 
            :download="configureDownload()"
            target="_blank"
          >
            Download current items (.csv)
          </CButton>
          <CButton
            v-if="data && !downloadingOpenOrders"
            color="success"
            class="mb-2 ml-2"
            size="sm"
            @click="getOpenOrders()"
          >
            Download Open Orders for Channel
          </CButton>
          <CButton
            v-if="data && downloadingOpenOrders"
            color="success"
            class="mb-2 ml-2"
            size="sm"
            id="openOrdersButton"
            :disabled="downloadingOpenOrders"
          >
            Download Open Orders for Channel
          </CButton>
          <small-loader v-if="downloadingOpenOrders"></small-loader>
          <CDataTable
            v-if="data && fields"
            :items="data"
            column-filter
            hover
            sorter
            :fields="fields"
            @row-clicked="rowClicked"
          >
            <template #daily_booked="{item}">
              <td>
                {{parseInt(item.daily_booked).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
              </td>
            </template>
            <template #daily_shipped="{item}">
              <td>
                {{parseInt(item.daily_shipped).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
              </td>
            </template>
            <template #booked_units="{item}">
              <td>
                {{parseInt(item.booked_units).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
              </td>
            </template>
            <template #shipped_units="{item}">
              <td>
                {{parseInt(item.shipped_units).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
              </td>
            </template>
            <template #late_open="{item}">
              <td>
                {{parseInt(item.late_open).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
              </td>
            </template>
            <template #balance_open="{item}">
              <td>
                {{parseInt(item.balance_open).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
              </td>
            </template>
            <template #total_open="{item}">
              <td>
                {{parseInt(item.total_open).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
              </td>
            </template>
            <template #late_open-header>
              Curr & Late Open
            </template>
          </CDataTable>
        </div>
        <small-loader v-else></small-loader>
      </CCardBody>
    </CCard>

    <CCard v-if="selectedItem">
      <CCardHeader>{{selectedItem.area}} Open Orders</CCardHeader>
      <CCardBody>
        <open-orders :selectedItem="selectedItem"></open-orders>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import OpenOrders from './open_orders'
var methods = {}

methods.configureDownload = function () {
  console.log('configure download')
  console.log(this.data)
  if (this.data) {
    var area = this.data[0].area + '_' + this.date + '_sales_dash.csv'
  } else {
    var area = ''
  }
  // // area + '_sales_dashboard.csv'
  // var area = 'Testing.csv'
  return area
}

methods.configureOpenDownload = function () {
  var area = this.data[0].area + '_all_open_orders.csv'
  // // area + '_sales_dashboard.csv'
  // var area = 'Testing.csv'
  return area
}

methods.rowClicked = function (item) {
  console.log(item)
  this.selectedItemLoading = true
  this.selectedItem = item
  var that = this
  setTimeout(function () {
    that.selectedItemLoading = false
  }, 1000)
}

methods.setCurrentItems = function (val) {
  this.currentItems = val
}

// methods.getOpenOrders = function () {
//   this.downloadingOpenOrders = true
//   var that = this
//   const postData = {
//     item: this.channel
//   }
//   console.log(postData)
//   axios.post(this.$apiAdress + '/api/getAllOpenOrders?token=' + localStorage.getItem('api_token'), postData).then(response => {
//     this.openOrderItems = response.data
    
//     setTimeout(function () {
//       // console.log($('#openOrdersButton'))
//       // $('#openOrdersButton')[0].trigger('click')
//       // console.log('button clicked')
//       var hiddenElement = document.createElement('a');  
//       hiddenElement.href = that.openOrderCode;  
//       hiddenElement.target = '_blank';  
        
//       //provide the name for the CSV file to be downloaded  
//       hiddenElement.download = that.configureOpenDownload();  
//       setTimeout(function () {
//         hiddenElement.click();  
//         that.downloadingOpenOrders = false
//       }, 2000)
//     }, 1000)
//   })
// }

methods.getOpenOrders = function () {
  this.downloadingOpenOrders = true;
  const postData = { item: this.channel };
  console.log(postData);

  axios.post(this.$apiAdress + '/api/getAllOpenOrders?token=' + localStorage.getItem('api_token'), postData).then(response => {
    this.openOrderItems = response.data;
    console.log(response)
    console.log('open orders')
    // console.log(response.data)
    var that = this
    // setTimeout(() => {
      if (that.openOrderCode) {
        const hiddenElement = document.createElement('a');
        hiddenElement.href = that.openOrderCode;
        hiddenElement.target = '_blank';
        hiddenElement.download = that.configureOpenDownload();
        
        // Trigger the download after ensuring the file is ready
        hiddenElement.click();
        that.downloadingOpenOrders = false;
      } else {
        console.error('Failed to generate CSV file.');
        that.downloadingOpenOrders = false;
      }
    // }, 10000);  // Give enough time for the CSV content to be fully ready
  }).catch(error => {
    console.error('Error fetching open orders:', error);
    this.downloadingOpenOrders = false;
  });
}

methods.getDataObj = function (data) {
  var obj = {}
  data.forEach(function (val) {
    var n = val.sold_to_number + '_' + val.div
    if (!obj[n]) {
      obj[n] = {
        area: val.area,
        sold_to_number: val.sold_to_number,
        sold_to_name: val.sold_to_name,
        daily_booked: 0,
        daily_shipped: 0,
        booked_units: 0,
        shipped_units: 0
      }
    }
    obj[n].daily_booked += parseFloat(val.daily_booked)
    obj[n].daily_shipped += parseFloat(val.daily_shipped)
    obj[n].booked_units += parseFloat(val.booked_units)
    obj[n].shipped_units += parseFloat(val.shipped_units)
  })
  for (var key in obj) {
    obj[key].daily_shipped = parseInt(obj[key].daily_shipped)
    obj[key].daily_booked = parseInt(obj[key].daily_booked)
    obj[key].booked_units = parseInt(obj[key].booked_units)
    obj[key].shipped_units = parseInt(obj[key].shipped_units)
  }
  return obj
}

methods.getData = function (obj) {
  var arr = []
  for (var key in obj) {
    arr.push(obj[key])
  }
  return arr
}

methods.getMonthly = function () {
  this.loading = true
  const postData = {
    area: this.reportData,
    date: this.date
  }
  axios.post(this.$apiAdress + '/api/getMonthlyReport?token=' + localStorage.getItem('api_token'), postData).then(res => {
    console.log('monthly table')
    console.log(res)
    // this.getDataObj(response.data).then(res => {
    //   this.getData(res).then(r => {
    //     this.data = r
    //     this.loading = false
    //   })
    // })
    var obj = this.getDataObj(res.data)
    this.data = this.getData(obj)
    this.loading = false
  })
}

export default {
  name: 'SalesDashboard',
  props: ['reportData', 'date', 'reportType'],
  data: () => {
    return {
      headers: ['sold_to_number', 'daily_booked', 'daily_shipped', 'booked_units', 'shipped_units'],
      data: null,
      dashShow: true,
      fields: null,
      // reportData: null,
      currentItems: '',
      loading: false,
      selectedItem: null,
      openOrderItems: null,
      downloadingOpenOrders: false,
      channel: '',
      selectedItemLoading: false
      // currentItems: this.reportData.slice()
    }
  },
  computed: {
    csvContent () {
      if (this.data) {
        var arr = []
        var that = this
        this.data.forEach(val => {
          var obj = {}
          that.fields.forEach(field => {
            obj[field] = val[field] ? val[field].toString().replaceAll(",", " ") : ''
          })
          arr.push(obj)
        })
        return arr.map(item => Object.values(item).join(',')).join('\n')
      } else {
        return ''
      }
    },
    csvCode () {
      if (this.csvContent) {
        var str = ''
        this.fields.forEach(v => {
          var val = v ? v.toString().replaceAll(",", " ") : ''
          str += val + ','
        })
        return 'data:text/csv;charset=utf-8,' + encodeURIComponent(str.slice(0, -1) + '%0A' + this.csvContent)
      } else {
        return ''
      }
    },
    openOrderContent() {
      if (this.openOrderItems) {
        console.log("Generating CSV for:", this.openOrderItems);  // Log the items being processed

        const fields = ['sold_to_number', 'sold_to_name', 'rep_name', 'order_number', 'po_number', 'product_class', 'program', 'csr', 'units', 'price', 'order_status', 'release_status', 'enter_date', 'ship_date', 'event_date'];
        const arr = [];

        this.openOrderItems.forEach(val => {
          const obj = {};

          fields.forEach(field => {
            // Replace null, undefined, or missing fields with an empty string and remove double quotes
            let fieldValue = val[field] != null ? val[field].toString().replace(/"/g, '') : '';  // Remove double quotes
            obj[field] = fieldValue.replaceAll(",", " ");  // Replace commas to avoid breaking the CSV structure
          });

          arr.push(obj);
        });

        // Convert array of objects to CSV format (comma-separated values)
        return arr.map(item => Object.values(item).join(',')).join('\n');
      } else {
        console.log("No open order items found.");
        return null;
      }
    },
    openOrderCode() {
      if (this.openOrderContent) {
        console.log('there is order content')
        const fields = ['sold_to_number', 'sold_to_name', 'rep_name', 'order_number', 'po_number', 'product_class', 'program', 'csr', 'units', 'price', 'order_status', 'release_status', 'enter_date', 'ship_date', 'event_date'];
        let str = fields.map(field => field.replaceAll(",", " ")).join(",") + "\n";  // CSV header without quotes

        return 'data:text/csv;charset=utf-8,' + encodeURIComponent(str + this.openOrderContent);
      } else {
        console.log('no order content')
        return null;
      }
    }
  },
  components: {
    OpenOrders
  },
  methods: methods,
  mounted: function(){
    var arr = []
    var that = this
    console.log(this.reportData)
    if (this.reportType !== 'monthly') {
      this.reportData.forEach(function (val) {
        if (that.reportType === 'orders_in_system') {
          // if (val.late_open != null || val.balance_open != null) {
          if (val.total_open !== null) {
            arr.push(val)
          }
        } else {
          if (val.daily_booked != null || val.daily_shipped != null) {
            arr.push(val)
          }
        }
      })
      this.channel = this.reportData[0].area
    } else {
      this.getMonthly()
      this.channel = this.reportData
    }
    if (this.reportType === 'orders_in_system') {
      this.fields = ['sold_to_number', 'sold_to_name', 'late_open', 'balance_open', 'total_open']
    } else {
      this.fields = ['sold_to_number', 'sold_to_name', 'daily_booked', 'daily_shipped', 'booked_units', 'shipped_units']
    }
    this.data = arr
  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
